<div
  class="item-row"
  role="button"
  tabindex="0"
  [class.item-row-na]="isNotApplicable()"
  [class.item-row-attention]="needsAttention()"
  [class.item-row-restricted]="isRestrictedWithoutAccess()"
  [class.item-row-selection]="selectionMode()"
  [class.item-row-selected]="selected()"
  [attr.aria-label]="item().name"
  [dataSelector]="'cxp-crl-item-row'"
  (click)="onActivate()"
  (keydown)="onKeydown($event)"
>
  <div class="item-left">
    @if (selectionMode()) {
      <mat-checkbox
        class="item-select"
        [checked]="selected()"
        [disabled]="!isSelectable()"
        [attr.aria-label]="'Select ' + item().name"
        [dataSelector]="'cxp-crl-item-select'"
        (click)="$event.stopPropagation()"
        (change)="onSelectionToggled()"
      ></mat-checkbox>
    }

    @if (isRestrictedWithoutAccess()) {
      <aiwyn-icon
        name="lock"
        class="item-status-icon item-status-icon-locked"
        aria-label="Restricted"
        [dataSelector]="'cxp-crl-item-restricted'"
        [height]="20"
        [width]="20"
      ></aiwyn-icon>
    } @else {
      <aiwyn-icon
        [name]="statusIcon().name"
        class="item-status-icon"
        [class.item-status-icon-open]="statusIcon().tone === 'open'"
        [class.item-status-icon-submitted]="statusIcon().tone === 'submitted'"
        [class.item-status-icon-attention]="statusIcon().tone === 'attention'"
        [tooltip]="statusTooltip()"
        [tooltipEnabled]="!!statusTooltip()"
        position="above"
        [attr.aria-label]="item().statusLabel"
        [dataSelector]="'cxp-crl-item-status-icon'"
        [height]="20"
        [width]="20"
      ></aiwyn-icon>
    }

    <div class="item-body">
      <div class="item-main">
        <p class="item-title">
          @if (displayNumber()) {
            <span class="item-number">{{ displayNumber() }}</span>
          }
          <span class="item-name" tooltipOverflow position="above">{{ item().name }}</span>
          @if (isRestrictedWithAccess()) {
            <aiwyn-icon
              name="lock"
              class="item-title-lock"
              aria-label="Restricted"
              [dataSelector]="'cxp-crl-item-restricted-inline'"
              [height]="16"
              [width]="16"
            ></aiwyn-icon>
          }
        </p>

        @if (item().description) {
          <p class="item-description" [innerHTML]="item().description | sanitizedHtml"></p>
        }

        @if (metadata(); as metadata) {
          <p
            class="item-metadata"
            [class.item-metadata-overdue]="metadata.isOverdue"
            [class.item-metadata-struck]="metadata.isStruckThrough"
          >
            {{ metadata.label }} {{ metadata.date | safeDate: 'MMM d' }}
          </p>
        }

        @if (isRestrictedWithoutAccess()) {
          <p class="item-restricted-notice">Restricted – only certain people can see this request's details.</p>
        }

        @if (isNotApplicable() && item().notApplicableReason) {
          <p class="item-na-reason">{{ item().notApplicableReason }}</p>
        }
      </div>

      @if (addons().length > 0) {
        <div class="item-addons">
          @for (addon of addons(); track addon.kind) {
            @switch (addon.kind) {
              @case ('comments') {
                <button
                  type="button"
                  class="item-addon-comments"
                  [class.item-addon-comments-unread]="addon.hasUnread"
                  [attr.aria-label]="addon.hasUnread ? 'Open unread comments' : 'Open comments'"
                  [dataSelector]="'cxp-crl-item-comments'"
                  (click)="onCommentsActivated($event)"
                >
                  <aiwyn-icon name="message-square" [height]="12" [width]="12"></aiwyn-icon>
                </button>
              }
              @case ('notApplicable') {
                <span class="item-addon-na">
                  <span class="item-addon-na-label">Marked as N/A</span>
                  @if (addon.canUndo) {
                    <button
                      type="button"
                      class="item-addon-undo"
                      aria-label="Undo marked as not applicable"
                      [disabled]="undoPending()"
                      [dataSelector]="'cxp-crl-item-na-undo'"
                      (click)="onUndoNotApplicable($event)"
                    >
                      Undo
                    </button>
                  }
                </span>
              }
              @case ('files') {
                <!--
                  Presentation only: the design's file popover is not built, so this
                  renders as the outlined button it looks like without being a
                  focusable control that does nothing.
                -->
                <span
                  class="item-addon-files"
                  [attr.aria-label]="addon.label + ' attached'"
                  [dataSelector]="'cxp-crl-item-files'"
                >
                  <aiwyn-icon name="paperclip" class="item-addon-files-icon" [height]="12" [width]="12"></aiwyn-icon>
                  {{ addon.label }}
                </span>
              }
              @case ('assignees') {
                <span
                  class="item-addon-avatars"
                  [tooltip]="addon.names"
                  position="above"
                  [attr.aria-label]="'Assigned to ' + addon.names"
                  [dataSelector]="'cxp-crl-item-assignees'"
                >
                  @for (avatar of addon.avatars; track avatar.key) {
                    <span class="item-addon-avatar item-addon-avatar--{{ avatar.colorKey }}" aria-hidden="true">
                      {{ avatar.initials }}
                    </span>
                  }
                  @if (addon.overflowCount > 0) {
                    <span class="item-addon-avatar item-addon-avatar-overflow" aria-hidden="true">
                      +{{ addon.overflowCount }}
                    </span>
                  }
                </span>
              }
            }
          }
        </div>
      }
    </div>
  </div>
</div>
